// documentModeはIE特有のプロパティである。
// このプロパティが存在する=IEである。
export const isIe = document['documentMode'] !== undefined;

// IEでは自動的にURLをエンコードしないため、手動でエンコードする必要がある。
// それに対して、Chromeなどでは自動的にエンコードするため、エンコードすると逆に二重エンコードになってしまう。
// see https://social.msdn.microsoft.com/Forums/en-US/3330047c-d6f1-43f2-adc8-21217f375954/chrome-encodes-a-url-but-internet-explorer-11-doesnt?forum=iewebdevelopment
// （追記）TRYLION_HC-204　上記二重エンコードは発生しないことを確認したため、ブラウザ問わず手動でエンコードするようにする
export const encodeString = (stringTobeEncoded: string): string => {
    return encodeURIComponent(stringTobeEncoded)
}
